module.exports = __webpack_public_path__ + "img/about-8.aa762547.jpg";